<template>
    <el-container class="liucheng" v-loading="loading">

        <el-aside class="left" width="270px">
            <el-popover
                placement="top-start"
                width="200"
                trigger="manual"
                content="该项目的项目信息、电子协议、承诺书等信息在这里哦！"
                v-model="tishishow">
                    <span slot="reference"></span>
            </el-popover>
            <project-operate 
                :iszc="iszc"
                class="project"
                ref="projectOperate"
                :procodeInfo="procodeInfo"
                @goFrame="goFrame"
                @change="collapseChange">
            </project-operate>

            <div class="process" :style="'height:'+processHeight+'px'">
                <el-popover
                    placement="top-start"
                    width="200"
                    trigger="manual"
                    content="该招标项目流程在这里！"
                    v-model="tishishow">
                        <span slot="reference"></span>
                </el-popover>
                <flow-common
                    v-show="redirect=='common'"
                    :model="model"
                    :isInfo="isInfo"
                    ref="flowcommon"
                    @nodeClick="getProcessCheck"
                    @nodeAdd="nodeAdd">
                </flow-common>
                <flow-otherFlow 
                    v-show="redirect=='other'" 
                    :model="model" 
                    :isInfo="isInfo"
                    ref="flowotherFlow"
                    @nodeClick="getProcessCheck"
                    @nodeAdd="nodeAdd">
                </flow-otherFlow>
            </div>
        </el-aside>

        <el-main>
            <iframe 
                class="frame-item"
                :src="computedSrc" 
                frameborder="0"
                v-if="liuchengShow"
            ></iframe>
            <div style="text-align:center;margin-top:40px" v-if="!liuchengShow">
                <el-link type="danger" style="font-size:22px">{{text}}</el-link>
            </div>
        </el-main>

        <el-dialog
            title="选择标段"
            :visible.sync="dialogVisible"
            style="text-align:left"
            width="30%">
            <div>
                <my-checkbox
                    model-str
                    str-spliter=","
                    v-model="bdcodes"
                    :data="model.bdList"
                    :props="{label:'bdname',value:'bdcode'}">
                </my-checkbox>
                
            </div>
            
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="yycd">确 定</el-button>
            </span>
        </el-dialog>
    </el-container>
</template>

<script>
import './style/flow.scss';
import './config/index.js'
const fileDownload = require('@views/bidding/config/jquery.fileDownload');
export default {
    components: {
        ProjectOperate: () => import('./projectOperate/index'),
        FlowCommon: () => import('./common/index'),
        FlowOtherFlow: () => import('./otherFlow/index'),
    },
    data() {
        return {
            computedSrc:'',
            iszc:false,
            redirect:'common',
            procodeInfo:{},
            model:{},
            dialogVisible:false,
            bdcodes:'',
            loading:false,
            liuchengShow:true,
            text:'',
            processHeight:0,
            projectHeight:0,
            firstGo:1,//第一次进入
            isInfo:{},//是否有数据
            nodeConfig:{},//配置文件数据
            tishishow:true,
        }
    },
    computed: {
        id: function() {
            return this.getQuery('id') || '';
        },
    },
    methods: {
        gotoNode({url, query},isnew) {
            if(isnew!=='1') {
                
                if(query){
                    var search = toSearch(query,true)
                    this.computedSrc = url+'&'+search;
                }else{
                    this.computedSrc = url
                }
            } else {
                
                this.computedSrc = window.location.pathname+'?t='+Math.random()*10 + '#'+url
            }
        },
        // 项目信息打开iframe
        goFrame(url){
            this.liuchengShow = true;
            this.computedSrc = window.location.pathname+'?t='+Math.random()*10+url; 
        },
        // 节点打开iframe
        nodeClick(data){
            var that = this;
            if(data.issh=='1'&&that.model.dateRule){
                that.computedSrc = data.shurl+that.id; 
                return;
            }
            // 特殊节点点击
            if(data.isclick=='click'){
                //预约场地
                if(data.nodename=='获取开标室'||data.nodename=='预约场地'){
                    
                    if(that.model.ext4=='130300'){
                        ShowMsg('请联系交易中心获取开标室')
                        return
                    }
                    // if(that.model.jyZxCode=='J13052301'){
                    //     ShowMsg('请联系内丘县公共资源交易中心工作人员预约')
                    //     return
                    // }
                    if(that.model.bdCodes==null||that.model.bdCodes==''){
                        ShowMsg('请先推送标段信息')
                        return
                    }else{
                        if(that.model.bdList.length==1){
                            if(that.model.ng){
                                // 经济开发区 转code
                                if(that.model.regionCode=='130583'){
                                    window.open(that.model.xtCd+'/sszt-zyjyTrading/zyjy/xtdj/zyjyDsfbulletin/cdyy?syms='+that.model.bdCodes+'&region_Code=130571')
                                }else if(that.model.regionCode=='130584'){
                                    window.open(that.model.xtCd+'/sszt-zyjyTrading/zyjy/xtdj/zyjyDsfbulletin/cdyy?syms='+that.model.bdCodes+'&region_Code=130596')
                                }else{
                                    window.open(that.model.xtCd+'/sszt-zyjyTrading/zyjy/xtdj/zyjyDsfbulletin/cdyy?syms='+that.model.bdCodes+'&region_Code='+that.model.regionCode)
                                }
                                
                            }else{
                                window.open(that.model.xtCd+'/sszt-zyjyTrading/zyjy/xtdj/zyjyDsfbulletin/cdyy?syms='+that.model.bdCodes)
                            }
                        }else{
                            that.dialogVisible = true;
                        }
                        
                    }
                }else if(data.nodename=='数据导出'){
                    //数据导出
                    $.get(`${that.getGetters('ageUrl')}/Zbdl/sjtj/exportStatus.json`, {
                        zbprocode:that.id,
                        t:Math.random(),
                    }, data => {
                        if(data.code=='v'){
                            // 遮罩
                            var loading = that.$loading({
                                lock: true,
                                text: '正在导出',
                                spinner: 'el-icon-loading',
                                background: 'rgba(225, 225, 225, 0.7)'
                            });
                            var httpMethod = 'post';
                            var url = '/Zbdl/sjtj/exportExcel.do?zbprocode='+that.id+'&isqz=1'
                            $.fileDownload(url, {
                                httpMethod: httpMethod,
                                // 因为这个插件貌似只支持URL参数,所以要用jquery param将js对象转成URL参数
                                data: '',
                                prepareCallback: function (url) {
                                    console.log("正在导出...");
                                
                                },
                                //要想成功回调失败和成功方法，要在响应首部加 response.setHeader("Set-Cookie", "fileDownload=true; path=/");
                                successCallback: function (url) {
                                    console.log("导出成功");
                                    loading.close()
                                },
                                failCallback: function (html, url) {
                                    console.log("导出失败");
                                    loading.close()
                                }
                            });
                        }else if(data.code=='error'){
                            ShowMsg(data.msg,'warning')
                        }
                        
                    })
                    
                    
                }
                
            }else if(data.isclick=='open_kb'){
                window.open(data.nodeurl+that.id)
            }else{
                // 半流程节点跳转
                if(data.isblc=='1'&&that.model.zbGj){
                    that.computedSrc = data.hisurl+that.id;
                }else{
                    //正常节点跳转
                    that.gotoNode({
                        url: data.nodeurl + that.id,
                        
                    },data.isnew)
                    
                }
                
            }

        },
        // 邢台预约场地
        yycd(){
            var that = this
            if(that.bdcodes==''){
                ShowMsg('请选择标段')
                return
            }
            if(that.model.ng){
                // 经济开发区 转code
                if(that.model.regionCode=='130583'){
                    window.open(that.model.xtCd+'/sszt-zyjyTrading/zyjy/xtdj/zyjyDsfbulletin/cdyy?syms='+that.bdcodes+'&region_Code=130571')
                }else if(that.model.regionCode=='130584'){
                    window.open(that.model.xtCd+'/sszt-zyjyTrading/zyjy/xtdj/zyjyDsfbulletin/cdyy?syms='+that.bdcodes+'&region_Code=130596')
                }else{
                    window.open(that.model.xtCd+'/sszt-zyjyTrading/zyjy/xtdj/zyjyDsfbulletin/cdyy?syms='+that.bdcodes+'&region_Code='+that.model.regionCode)
                }
            }else{
                window.open(that.model.xtCd+'/sszt-zyjyTrading/zyjy/xtdj/zyjyDsfbulletin/cdyy?syms='+that.bdcodes)
            }
        },
        // 获取节点
        getProcessNode(){
            var that = this;
            that.model = {}
            that.$get(`${this.getGetters('mngUrl')}/v2/process/node.json`, {
                id:that.getQuery('id')
            }, (data, res) => {
                that.model = data;
                if(that.model.processType==='TWO'||that.model.processType==='ZGYS'){
                    that.redirect = 'other';
                    that.$refs.flowotherFlow.init(data)
                }else{
                    that.redirect = 'common';
                    that.$refs.flowcommon.init(data)
                }
                that.loading = false;
            });
        },
        getProcessCheck(item){
            var that = this;
            // 判断是否可以正常进入流程
            $.post(`${this.getGetters('mngUrl')}/v2/process/check.json`, {
                id:that.getQuery('id')
            }, (data, res) => {
                if(data.code=='v'){
                    that.liuchengShow = true;
                    if(that.firstGo==1){
                        that.computedSrc = window.location.pathname+'?t='+Math.random()*10 + '#'+'/bidding/projectflow/fangan/biaoduan/list?procode='+that.id;
                        that.firstGo = that.firstGo+1
                    }else{
                        that.nodeClick(item)
                    }
                }else if(data.code=='error'){
                    that.liuchengShow = false;
                    that.text = data.msg;
                    ShowMsg(data.msg);
                    setTimeout(function () {
                        that.$refs.projectOperate.procodeInfoInt();
                    }, 500)
                    
                    return;
                }
            });
        },
        // 计算节点高度
        getprocessHeight(val){
            this.processHeight = window.innerHeight - val;
        },
        collapseChange(val){
            if(val==0){
                this.getprocessHeight(59);
            }else{
                this.getprocessHeight(this.projectHeight);
            }
            
        },
        // 进入添加页面
        nodeAdd(data){
            var that = this;
            that.nodeConfig.forEach(function(item){
                if(item.nodecode==data.nodecode){
                    if(data.nodecode.indexOf("A0") != -1){
                        that.computedSrc = window.location.pathname+'?t='+Math.random()*10 + '#'+item.addUrl + that.id+'&isZc='+that.iszc;
                    }
                    
                }
            })
      
     
        }
        
    },
    mounted() {
        var that = this;
        that.loading = true;
        if(that.getQuery('ext3')!='null'){
            that.iszc = true;
        }
        that.$get(`${this.getGetters('mngUrl')}/v2/Zbdl/ZbProject/processInfo.json`, {
            id:that.getQuery('id')
        }, (data, res) => {
           that.procodeInfo = data;
           setTimeout(function(){
                that.projectHeight = $('.project').height()+50;
                that.getprocessHeight(that.projectHeight)
           },500);
           
        });
        // 流程节点是否有数据
        that.$post(`${this.getGetters('mngUrl')}/v2/process/izData.json`, {
            id:that.getQuery('id')
        }, (data, res) => {
           that.isInfo = data;
        });
        that.getProcessNode();
        that.getProcessCheck();
        that.nodeConfig = window.Node;
        if (!getSession('user').lead.process) {
            setTimeout(function () {
                that.tishishow = false;
            }, 5000);
            that.$post(`${this.getGetters('mngUrl')}/v2/system/statistics/leadAccess.json`, {
                leadtype:'process'
            }, data => {
                var obj = getSession('user')
                obj.lead.process = true
                setSession('user', obj);
            });
        } else {
            that.tishishow = false;
        }
    }
}
</script>

<style scoped lang="sass">
    .liucheng{ height: 100%;}
    .liucheng .left{ padding: 0px 0px 10px 10px; border-right: 1px solid #f0f2f5;}
    .frame-item{ width: 100%; height: calc(100% - 38px)}
    .process{ overflow: auto; }
    /deep/ .el-popover--plain{ padding: 5px; background-color: #e6a23c; color: #fff; margin-left: 30px; }
</style>